import {
  stringIsInvalid,
  stringMaxLengthIsInvalid,
} from 'store/utils/validators';
import MESSAGES from 'constants/messages';

export default ({ name }) => {
  const errors = {};

  if (!name || stringIsInvalid(name)) {
    errors.name = MESSAGES.CONTEXTS.NAME.REGEX;
  }

  if (stringMaxLengthIsInvalid(name)) {
    errors.name = MESSAGES.CONTEXTS.NAME.MAX_LENGTH;
  }

  return errors;
};
